import React from 'react';
import PropTypes from 'prop-types';

import {Autocomplete} from 'views/components';
import {translate} from '../Translate';

import momentTZ from 'moment-timezone';

const TimezoneAutocomplete = (props) => {
  const {selectedTimezone: selectedTimezoneParent, onTimezoneChange} = props;

  const [selectedTimezone, setSelectedTimezone] = React.useState(selectedTimezoneParent);
  const [frequentlyUsedTimezones, setFrequentlyUsedTimezones] = React.useState([]);

  // Load frequently used timezone
  React.useEffect(() => {
    const storedFrequentlyUsedTimezones = localStorage.getItem('frequently-used-timezones');
    if (storedFrequentlyUsedTimezones) {
      setFrequentlyUsedTimezones(JSON.parse(storedFrequentlyUsedTimezones));
    }
  }, []);

  const makeTimezonesList = React.useCallback(() => {
    const timezones = momentTZ.tz.names();
    const futCopy = [...frequentlyUsedTimezones];
    if (!futCopy.find((fut) => fut === selectedTimezone)) {
      futCopy.push(selectedTimezone);
    }
    if (!futCopy.find((fut) => fut === momentTZ.tz.guess())) {
      futCopy.push(momentTZ.tz.guess());
    }
    const formatted = timezones.filter((t) => !futCopy.find((fut) => fut === t)).map((timezone) => {
      return {
        group: translate('timeFormat.Timezone.Timezones'),
        value: timezone,
        label: timezone,
      };
    });
    const formattedFrequently = futCopy.map((timezone) => {
      return {
        group: translate('timeFormat.Timezone.FrequentlyUsedTimezones'),
        value: timezone,
        label: timezone,
      };
    });
    return [...formattedFrequently, ...formatted];
  }, [frequentlyUsedTimezones, selectedTimezone]);

  const onSelectTimezone = (value) => {
    setSelectedTimezone(value.value);
    if (!frequentlyUsedTimezones.find((fut) => fut === value.value)) {
      const updated = [...frequentlyUsedTimezones, value.value];
      setFrequentlyUsedTimezones(updated);
      localStorage.setItem('frequently-used-timezones', JSON.stringify(updated));
    }
    onTimezoneChange(value.value);
  };

  return (
    <Autocomplete
      options={makeTimezonesList()}
      value={selectedTimezone}
      label={translate('timeFormat.Timezone.ViewingScheduleInTimezone')}
      onChange={onSelectTimezone}
      sx={{minWidth: {xs: '192px', md: '256px'}}}
      renderOption={(props, option) => (
        <li {...props} key={option.value}>
          {option.label}
        </li>
      )}
      groupBy={(dropdownItem) => dropdownItem.group}
      isOptionEqualToValue={(option, value) => option.value === value}
      disableClearable
    />
  );
};

TimezoneAutocomplete.propTypes = {
  selectedTimezone: PropTypes.string.isRequired,
  onTimezoneChange: PropTypes.func.isRequired,
};
export default TimezoneAutocomplete;
